import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import loadable from 'react-loadable';
import LoadingComponent from 'components/Loading';
// 3rd
import 'styles/antd.less';
import 'styles/bootstrap/bootstrap.scss'
// custom
import "styles/layout.scss"
import "styles/theme.scss"
import "styles/ui.scss"
import "styles/vendors.scss"

let AsyncException = loadable({
  loader: () => import('routes/exception/'),
  loading: LoadingComponent
})
let AsyncSetNewPwdMentee = loadable({
  loader: () => import('routes/mentee/routes/forgot-password'),
  loading: LoadingComponent
})
let AsyncSetNewPwdOrg = loadable({
  loader: () => import('routes/organizer/routes/forgot-password'),
  loading: LoadingComponent
})
let AsyncHomePage = loadable({
  loader: () => import('routes/home/'),
  loading: LoadingComponent
})
let AsyncMentorListPage = loadable({
  loader: () => import('routes/all-mentors'),
  loading: LoadingComponent
})
let AsyncMenteeFeedback = loadable({
  loader: () => import('routes/mentee/routes/feedback'),
  loading: LoadingComponent
})

let AsyncMenteeFeedbackForm = loadable({
  loader: () => import('routes/mentee/routes/feedbackform'),
  loading: LoadingComponent
})

let AsyncMenteeFeedbackThank = loadable({
  loader: () => import('routes/mentee/routes/feedbackthank'),
  loading: LoadingComponent
})

let AsyncMentee = loadable({
  loader: () => import('components/Layout/AppLayout/'),
  loading: LoadingComponent
})
let AsyncMentor = loadable({
  loader: () => import('components/Layout/AppLayoutMentor/'),
  loading: LoadingComponent
})
let AsyncOrganizer = loadable({
  loader: () => import('components/Layout/AppLayoutOrganizer/'),
  loading: LoadingComponent
})
let AsyncMentorPublicProfile = loadable({
  loader: () => import('routes/view/'),
  loading: LoadingComponent
})
let AsyncTermsConditions = loadable({
  loader: () => import('routes/termscondition/'),
  loading: LoadingComponent
})
let FAQPages = loadable({
  loader: () => import('routes/faq/'),
  loading: LoadingComponent
})

class App extends React.Component {
  render() {
    const { match, location } = this.props;
    const isRoot = location.pathname === '/' ? true : false;
    if (isRoot) {
      return (<Redirect to={'/home'} />);
    }

    return (
      <div id="app">
        <Route path={`${match.url}termscondition`} component={AsyncTermsConditions} />
        <Route path={`${match.url}exception`} component={AsyncException} />
        <Route path={`${match.url}faq`} component={FAQPages} />
        <Route path={`${match.url}mentee`} component={AsyncMentee} />
        <Route path={`${match.url}mentor`} component={AsyncMentor} />
        <Route path={`${match.url}organizer`} component={AsyncOrganizer} />
        <Route path={`${match.url}home`} component={AsyncHomePage} />
        <Route path={`${match.url}home/:Ref`} component={AsyncHomePage} />
        <Route path={`${match.url}all-mentors`} component={AsyncMentorListPage} />
        <Route path={`${match.url}feedback/:role`} component={AsyncMenteeFeedback} />
        <Route path={`${match.url}feedback-form`} component={AsyncMenteeFeedbackForm} />
        <Route path={`${match.url}feedback-thank`} component={AsyncMenteeFeedbackThank} />
        <Route path={`${match.url}reset-mentee/:Code`} component={AsyncSetNewPwdMentee} />
        <Route path={`${match.url}reset-org/:Code`} component={AsyncSetNewPwdOrg} />
        <Route path={`${match.url}view`} component={AsyncMentorPublicProfile} />
      </div>
    );
  }
}

export default App;
